import { render, staticRenderFns } from "./comp-hotpicker.vue?vue&type=template&id=cbefb3cc&scoped=true"
import script from "./comp-hotpicker.vue?vue&type=script&lang=js"
export * from "./comp-hotpicker.vue?vue&type=script&lang=js"
import style0 from "./comp-hotpicker.vue?vue&type=style&index=0&id=cbefb3cc&prod&lang=scss&scoped=true"
import style1 from "./comp-hotpicker.vue?vue&type=style&index=1&id=cbefb3cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbefb3cc",
  null
  
)

export default component.exports